import setAuditLogs from './setAuditLogs';
import setMoreAuditLogs from './setMoreAuditLogs';
import reset from './reset';

export default {
  setAuditLogs,
  setMoreAuditLogs,
  reset,
};
